import { render, staticRenderFns } from "./EventsCreate.vue?vue&type=template&id=3b94a456"
import script from "./EventsCreate.vue?vue&type=script&lang=js"
export * from "./EventsCreate.vue?vue&type=script&lang=js"
import style0 from "./EventsCreate.vue?vue&type=style&index=0&id=3b94a456&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports